module.exports = __webpack_public_path__ + "img/beer_id-67.1a4dbb5c.png";